// DEPRECATED
// Use i18n instead
export default {
  individual: '1-2-1',
  fixed: 'Fixed Length',
  one_many: 'Group Rolling Calendar',
  membership: 'Session 1, Day 1',
};
